import { render, staticRenderFns } from "./cadtiposconta.vue?vue&type=template&id=c2f79350&"
import script from "./cadtiposconta.vue?vue&type=script&lang=js&"
export * from "./cadtiposconta.vue?vue&type=script&lang=js&"
import style0 from "./cadtiposconta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports